const SELECTORS = {
  modalItem: '.free-gift-modal__item',
  modal: '.free-gift-modal',
  modalOpener: '[data-free-gift-modal-opener]',
  modalMessage: '[data-free-gifts-message]',
  modalAddButton: '[data-free-product-add-to-cart]',
  modalVariantSelect: 'select.free-product__select',
  modalTitleLink: '.free-product__title a',
  kiteRow: '.gfgFreeGiftMsgOptionRow',
  kiteTitle: '.gfgFreeGiftMsgTitle',
  kiteVariantSelect: '.gfgFreeGiftVariantSelect',
  kiteClaim: '.gfgFreeGiftClaimButton',
  cartDrawer: '[data-cart-drawer]',
  aos: '[data-aos]',
} as const;

function isHTMLSelectElement(value: unknown): value is HTMLSelectElement {
  return value instanceof HTMLSelectElement;
}

function normalize(value: string): string {
  return value.replace(/\s+/g, ' ').trim().toLowerCase();
}

function findKiteRowByTitle(title: string): HTMLElement | null {
  const needle = normalize(title);
  const rows = document.querySelectorAll(SELECTORS.kiteRow);
  for (let i = 0; i < rows.length; i += 1) {
    const row = rows[i];
    if (!(row instanceof HTMLElement)) continue;
    const titleEl = row.querySelector(SELECTORS.kiteTitle);
    const text = titleEl ? titleEl.textContent || '' : '';
    if (normalize(text) === needle) return row;
  }
  return null;
}

function addGiftViaKite(
  title: string,
  variantText: string | null,
  modal: Element | null,
): void {
  const row = findKiteRowByTitle(title);
  if (!row) return;

  if (variantText) {
    const select = row.querySelector(SELECTORS.kiteVariantSelect);
    if (select && isHTMLSelectElement(select)) {
      const needle = normalize(variantText);
      for (let i = 0; i < select.options.length; i += 1) {
        const opt = select.options[i];
        const label = opt.textContent || '';
        if (normalize(label) === needle) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          break;
        }
      }
    }
  }

  const claim = row.querySelector(SELECTORS.kiteClaim);
  if (claim instanceof HTMLElement) {
    claim.click();
    if (isWindowWithCart(window) && isCartWithGet(window.cart)) {
      const fn = window.cart.getCart;
      if (typeof fn === 'function')
        window.setTimeout(() => fn.call(window.cart), 800);
    }
    const opener = modal
      ? modal
          .closest(SELECTORS.modalMessage)
          ?.querySelector(SELECTORS.modalOpener)
      : null;
    if (opener instanceof HTMLElement) opener.setAttribute('hidden', 'true');
  }
}

function isWindowWithCart(obj: unknown): obj is Window & { cart: unknown } {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'cart' in (obj as Record<string, unknown>)
  );
}
function isCartWithGet(obj: unknown): obj is { getCart: unknown } {
  return (
    typeof obj === 'object' &&
    obj !== null &&
    'getCart' in (obj as Record<string, unknown>)
  );
}

document.addEventListener(
  'click',
  (event: MouseEvent) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest(SELECTORS.modalAddButton);
    if (!(button instanceof HTMLElement)) return;

    const item = button.closest(SELECTORS.modalItem);
    const modal = button.closest(SELECTORS.modal);
    if (!(item instanceof HTMLElement)) return;

    const titleEl = item.querySelector(SELECTORS.modalTitleLink);
    const title =
      titleEl instanceof HTMLElement ? (titleEl.textContent || '').trim() : '';
    if (title.length === 0) return;

    const select = item.querySelector(SELECTORS.modalVariantSelect);
    const variantText = isHTMLSelectElement(select)
      ? (() => {
          const opt = select.options[select.selectedIndex];
          const text = opt ? opt.textContent : null;
          return text ? text.trim() : null;
        })()
      : null;

    const kiteRow = findKiteRowByTitle(title);
    if (!kiteRow) return; 

    event.preventDefault();
    event.stopPropagation();

    addGiftViaKite(title, variantText, modal);
  },
  true,
);

document.addEventListener(
  'submit',
  (e: Event) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    const modal = form.closest('.free-gift-modal');
    if (!modal) return;

    const item = form.closest(SELECTORS.modalItem);
    const titleEl = item?.querySelector(SELECTORS.modalTitleLink);
    const title =
      titleEl instanceof HTMLElement ? (titleEl.textContent || '').trim() : '';
    if (title.length === 0) return;

    const kiteRow = findKiteRowByTitle(title);
    if (!kiteRow) return;

    e.preventDefault();
    e.stopPropagation();
  },
  true,
);

export {};

function isHTMLElement(value: unknown): value is HTMLElement {
  return value instanceof HTMLElement;
}

function revealAosInCart(): void {
  const containers: Element[] = [];
  const drawer = document.querySelector(SELECTORS.cartDrawer);
  if (isHTMLElement(drawer)) containers.push(drawer);
  const cartPage = document.querySelector('[data-cart-page]');
  if (isHTMLElement(cartPage)) containers.push(cartPage);

  if (containers.length === 0) return;

  containers.forEach((container) => {
    const elements = container.querySelectorAll(SELECTORS.aos);
    elements.forEach((el) => {
      if (!isHTMLElement(el)) return;
      el.classList.add('aos-animate');
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.transition = '';
    });
  });
}

document.addEventListener('theme:cart:loaded', revealAosInCart);
document.addEventListener('theme:cart:added', revealAosInCart);
document.addEventListener('theme:cart:open', revealAosInCart);
